module.exports = __webpack_public_path__ + "media/img/user2-160x160-6b9bafb2.jpg";